import { useState, useEffect } from 'react';

export const CollectionInfoFaq = ({ collection }) => {
  const [questions, setQuestions] = useState(
    collection?.collectionInfoLookup
      ?.filter((c) => c?.key === 'collection_faq')
      ?.map((c) => ({
        id: c?.id,
        question: c?.name,
        answer: c?.description,
        order: c?.order,
        isDefault: c?.isDefault,
        categories: c?.other.tags,
      }))
      .sort((a, b) => a.order - b.order),
  );

  const [existQuestions, setExistQuestions] = useState(false);
  useEffect(() => {
    if (questions && questions.length > 0) {
      setExistQuestions(true);
    } else {
      setExistQuestions(false);
    }
  }, [questions]);

  return (
    <div>
      {!existQuestions && (
        <div className='flex items-center justify-center '>
          <span className='text-sm font-semibold text-jacarta-900 dark:text-jacarta-100'>
            This collection has no FAQs yet
          </span>
        </div>
      )}
      {existQuestions && (
        <div className='flex flex-col gap-1.5'>
          {questions.map((question, index) => (
            <Question key={index} {...question} />
          ))}
        </div>
      )}
    </div>
  );
};

const Question = ({ question, answer, categories }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`rounded-xl inline-flex h-fit w-full select-none flex-col items-start justify-start gap-1.5 border border-jacarta-100 px-5 py-6 md:px-14
        ${
          !open
            ? 'cursor-pointer bg-white dark:bg-jacarta-800'
            : 'cursor-default bg-[#7445FF]/20 dark:bg-[#7445FF]/50'
        }
        text-jacarta-900 transition-all duration-500 ease-in-out dark:border-jacarta-600 dark:text-jacarta-100
      `}
      onClick={() => !open && setOpen(!open)}
    >
      {categories && (
        <span className='text-sm text-accent-light'>
          {categories.map((category) => (category != '' ? `#${category} ` : ''))}
        </span>
      )}
      <div
        className={`inline-flex w-full shrink grow basis-0 flex-col items-start justify-start gap-6 pt-0.5`}
      >
        <div className='inline-flex items-center justify-start gap-4 self-stretch'>
          <div className='flex shrink grow basis-0 items-start justify-start'>
            <div className='shrink grow basis-0 text-base font-semibold md:text-lg'>{question}</div>
          </div>
          <div className='flex items-center justify-center gap-2.5'>
            {!open ? (
              <svg className={`icon h-10 w-10 flex-shrink-0 fill-current`} viewBox='0 0 48 48'>
                <rect width='48' height='48' rx='24' fill='#F3F5F6' />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M25 17H23V23H17V25H23V31H25V25H31V23H25V17Z'
                  fill='black'
                />
              </svg>
            ) : (
              <svg
                className={`icon h-10 w-10 flex-shrink-0 cursor-pointer fill-current`}
                viewBox='0 0 48 48'
                onClick={() => setOpen(false)}
              >
                <rect width='48' height='48' rx='24' fill='black' />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M29.6569 19.7574L28.2426 18.3432L24 22.5859L19.7574 18.3432L18.3431 19.7574L22.5858 24.0001L18.3431 28.2427L19.7574 29.6569L24 25.4143L28.2426 29.6569L29.6569 28.2427L25.4142 24.0001L29.6569 19.7574Z'
                  fill='white'
                />
              </svg>
            )}
          </div>
        </div>
      </div>
      {open && <div className={`mt-3 text-sm !leading-6 md:text-base`}>{answer}</div>}
    </div>
  );
};
